import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "nav-app-download__label"
};
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { Iphone } from '@element-plus/icons-vue';
import { isIosDevice } from '@/composables/usePwaInstall.js';
import { resolveNavAppDownloadPath } from '@/domain/app-download/download-channels.js';
export default {
  __name: 'NavAppDownloadEntry',
  setup(__props) {
    const route = useRoute();
    const to = resolveNavAppDownloadPath({
      isIos: isIosDevice()
    });
    const visible = computed(() => {
      const name = String(route.name || '');
      return name !== 'AppDownload' && name !== 'AppDownloadGo' && name !== 'PwaLanding' && name !== 'PwaTutorial';
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_router_link = _resolveComponent("router-link");
      return visible.value ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: _unref(to),
        class: "nav-app-download",
        "aria-label": _ctx.$t('nav.downloadAppAria')
      }, {
        default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("span", {
          class: "nav-app-download__glow",
          "aria-hidden": "true"
        }, null, -1)), _createVNode(_component_el_icon, {
          class: "nav-app-download__icon",
          size: 16,
          "aria-hidden": "true"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Iphone))]),
          _: 1
        }), _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('nav.downloadAppLabel')), 1)]),
        _: 1
      }, 8, ["to", "aria-label"])) : _createCommentVNode("", true);
    };
  }
};